import React from "react";
import { KickLogo } from "@design-system/KickLogo/KickLogo";
import ArrowLeftRightIcon from "@icons/ui/ArrowLeftRight.svg?react";
import styles from "./AuthorizePage.module.scss";

interface AuthorizeHeaderProps {
    leftIcon: React.ReactNode;
    title: string;
}

export const AuthorizeHeader: React.FC<AuthorizeHeaderProps> = ({
    leftIcon,
    title,
}) => (
    <header className={styles.header}>
        <div className={styles.headerIcons}>
            {leftIcon}
            <ArrowLeftRightIcon className={styles.headerArrow} />
            <KickLogo variant="icon" size="2xl" label="Kick" />
        </div>
        <h3 className={styles.headerTitle}>{title}</h3>
    </header>
);
